




























import Vue from "vue"
import { Component, Prop } from "vue-property-decorator"
import catStreamStreamFactHeadline from "./fact_headline.vue"

@Component({
  components: {
    catStreamStreamFactHeadline,
  },
})
export default class FactTable extends Vue {
  @Prop({ default: () => "" })
  headline!: string

  @Prop({ default: () => [] })
  details!: { [key: string]: string }[]

  @Prop({
    default: (): { [key: string]: string }[] => [
      { text: "Parameter", value: "key" },
      { text: "Value", value: "value" },
    ],
  })
  tableHeaders: any

  search = ""

  get flattenedDetails() {
    const result: { key: string; value: string }[] = []

    this.details.forEach(detail => {
      const key = detail.key
      const value = detail.value

      if (typeof value === "object" && value !== null) {
        // If value is an object, flatten it
        Object.entries(value).forEach(([nestedKey, nestedValue]) => {
          result.push({ key: nestedKey, value: String(nestedValue) })
        })
      } else {
        // If value is a primitive, add it directly
        result.push({ key, value: String(value) })
      }
    })
    return result
  }
}
